import { useNavigate } from 'react-router-dom'

import { OrderItemTableRow } from '@src/components/OrderHistoryTable'
import { createContextLogger } from '@src/utils'

const logger = createContextLogger('useRepeatTrade')

/**
 * Hook for repeating a trade from order history
 */
export const useRepeatTrade = () => {
    const navigate = useNavigate()

    /**
     * Set up a trade with the same parameters as a previous order
     * @param item The order history item to repeat
     */
    const repeatTrade = (item: OrderItemTableRow) => {
        try {
            // Create a URL with all the necessary parameters for the swap
            // Include the sellAmount parameter to set the sell data value
            // Also include the token decimals to properly format the amount
            const url = `/swap?sellChain=${item.originChainId}&sellToken=${item.sellToken.address}&buyChain=${item.destChainId}&buyToken=${item.buyToken.address}&sellAmount=${item.sellQuantity}&sellDecimals=${item.sellToken.decimals}`

            logger.info('Repeating trade', {
                sellToken: item.sellToken.symbol,
                buyToken: item.buyToken.symbol,
                originChainId: item.originChainId,
                destChainId: item.destChainId,
                sellQuantity: item.sellQuantity,
                url,
            })

            // Navigate to the swap page with the token parameters and sell amount
            navigate(url)
        } catch (error) {
            logger.error('Failed to repeat trade', error)

            // Fallback to a simpler URL if something went wrong
            navigate('/swap')
        }
    }

    return { repeatTrade }
}
